import React from 'react';
import styled from 'styled-components';
import Spinner from './Spinner';

// Matches the actual usage in src/components/Loadable.js and all call sites:
//   <Loadable loading={loading}>children</Loadable>
//   <Loadable loading={true} />
//
// When loading=true: renders a centered spinner (size 35) filling parent.
// When loading=false/undefined: renders children as-is.

const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const SpinnerWrap = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export interface LoadableProps {
  loading?: boolean;
  children?: React.ReactNode;
}

const Loadable: React.FC<LoadableProps> = ({ loading = false, children }) => {
  if (loading) {
    return (
      <CenteredFlex>
        <SpinnerWrap>
          <Spinner size={35} />
        </SpinnerWrap>
      </CenteredFlex>
    );
  }
  return <>{children}</>;
};

export default Loadable;
